<template>
  <section class="link-list-block">
    <div class="title">{{ values.title || '' }}</div>
    <div class="links-wrapper">
      <div
        v-for="(item,idx) in values.links"
        :key="`link-block-item${idx}-${item.link}`"
      >
        <NuxtLink :to="item.link">
          {{ item.link_text }}
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { IBlockDefaultProps } from '#sitis/internal/models/common';

type LinkListBlockType = Omit<IBlockDefaultProps, 'values'> & {
	values: {
		title: string;
		links: Array<{
			link: string;
			link_text: string;
		}>
	}
}
const props = defineProps<LinkListBlockType>();

onMounted(() => {
  document.body.classList.add('two-columns-revers');
});

onBeforeUnmount(() => {
  document.body.classList.remove('two-columns-revers');
});

</script>

<style lang="scss">
.link-list-block {
	display: flex;
	flex-direction: column;
	gap: 24px;

	& .title {
		font-size: 16px;
		font-weight: 600;
		line-height: 22px;
	}

	& .links-wrapper {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	& a {
		font-size: 16px;
		font-weight: 500;
		line-height: 22px;
		color: var(--silver);
		text-decoration: none;

		&.router-link-active {
			color: var(--secondary-dark);
			position: relative;
			padding-left: 10px;

			&:before {
				content: '-';
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
			}
		}
	}
}

@media(max-width: 860px) {
	.two-columns-revers .cms__grid-block {
		flex-direction: column-reverse;
	}
}
</style>
